module.exports = __webpack_public_path__ + "img/01jujia.ee091d6a.png";